export const SIGNUP_REQUEST = "SIGNUP_REQUEST"
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS"
export const SIGNUP_FAILED = "SIGNUP_FAILED"

export const SIGNIN_REQUEST = "SIGNIN_REQUEST"
export const SIGNIN_SUCCESS = "SIGNIN_SUCCESS"
export const SIGNIN_FAILED = "SIGNIN_FAILED"


export const SIGNOUT_REQUEST = "SIGNOUT_REQUEST"
export const SIGNOUT_SUCCESS = "SIGNOUT_SUCCESS"
export const SIGNOUT_FAILED = "SIGNOUT_FAILED"